import { SelectOption } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'
import users from 'modules/core/store/collections/users'

import contractVersions from 'modules/contracts/store/collections/contractVersions'
import {
  employeeDirectlyManagedEmployees,
  employeeManagedEmployees,
} from 'modules/employees/store/collections/employeesContractVersions'
import memberships from 'modules/teams/store/collections/memberships'
import teams from 'modules/teams/store/collections/teams'
import { userIsManagingPeople } from 'modules/teams/store/userIsManagingPeople'

export const templateRevieweeOptions = (hasFullVisibility: boolean): SelectOption[] => {
  const result = []
  const managedEmployees = users.current.employee
    ? employeeManagedEmployees(users.current.employee, contractVersions)
    : []
  const directlyManagedEmployees = users.current.employee
    ? employeeDirectlyManagedEmployees(users.current.employee, contractVersions)
    : []

  if (hasFullVisibility) {
    result.push({
      value: 'all',
      label: i18n.t('surveys.performance.participants.everybody'),
    })
  }

  if (directlyManagedEmployees && directlyManagedEmployees.length > 0) {
    result.push({
      value: 'direct',
      label: i18n.t('surveys.performance.participants.direct'),
    })
  }

  if (
    userIsManagingPeople(teams, memberships, users.current.id) &&
    managedEmployees &&
    directlyManagedEmployees &&
    managedEmployees > directlyManagedEmployees
  ) {
    result.push({
      value: 'indirect',
      label: i18n.t('surveys.performance.participants.indirect'),
    })
  }

  return result
}
